module.exports = __webpack_public_path__ + "static/media/logo-ideal-horizontal.cf72ec79.png";